/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFileHeaderBlock } from './DatabaseFileHeaderBlock';
import {
    DatabaseFileHeaderBlockFromJSON,
    DatabaseFileHeaderBlockFromJSONTyped,
    DatabaseFileHeaderBlockToJSON,
} from './DatabaseFileHeaderBlock';
import type { DatabaseHeaderBlockActionType } from './DatabaseHeaderBlockActionType';
import {
    DatabaseHeaderBlockActionTypeFromJSON,
    DatabaseHeaderBlockActionTypeFromJSONTyped,
    DatabaseHeaderBlockActionTypeToJSON,
} from './DatabaseHeaderBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseCustomerLogoHeaderBlock
 */
export interface DatabaseCustomerLogoHeaderBlock extends DatabaseFileHeaderBlock {
    /**
     * 
     * @type {string}
     * @memberof DatabaseCustomerLogoHeaderBlock
     */
    objectFit?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseCustomerLogoHeaderBlock
     */
    objectPosition?: string;
}

/**
 * Check if a given object implements the DatabaseCustomerLogoHeaderBlock interface.
 */
export function instanceOfDatabaseCustomerLogoHeaderBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseCustomerLogoHeaderBlockFromJSON(json: any): DatabaseCustomerLogoHeaderBlock {
    return DatabaseCustomerLogoHeaderBlockFromJSONTyped(json, false);
}

export function DatabaseCustomerLogoHeaderBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseCustomerLogoHeaderBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFileHeaderBlockFromJSONTyped(json, ignoreDiscriminator),
        'objectFit': !exists(json, 'objectFit') ? undefined : json['objectFit'],
        'objectPosition': !exists(json, 'objectPosition') ? undefined : json['objectPosition'],
    };
}

export function DatabaseCustomerLogoHeaderBlockToJSON(value?: DatabaseCustomerLogoHeaderBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFileHeaderBlockToJSON(value),
        'objectFit': value.objectFit,
        'objectPosition': value.objectPosition,
    };
}

